var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 14.2053C13.723 14.2053 15.1199 12.8085 15.1199 11.0853C15.1199 9.3622 13.723 7.96533 11.9999 7.96533C10.2768 7.96533 8.87988 9.3622 8.87988 11.0853C8.87988 12.8085 10.2768 14.2053 11.9999 14.2053Z",
    stroke: "#8DC63F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61995 9.26539C5.58995 0.605393 18.42 0.615393 20.38 9.27539C21.53 14.3554 18.37 18.6554 15.6 21.3154C13.59 23.2554 10.41 23.2554 8.38995 21.3154C5.62995 18.6554 2.46995 14.3454 3.61995 9.26539Z",
    stroke: "#8DC63F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.468923fbf79a1bda2373bffbfb945a65.svg";
export { ForwardRef as ReactComponent };